import { useOfferingType } from '@/hooks/useOfferingType';
import { ProductEnrichmentReview } from './EnrichmentReview.product';
import { ServiceEnrichmentReview } from './EnrichmentReview.service';

/**
 * Thin router that delegates to the correct enrichment review view
 * based on the selected site's offering_type.
 *
 * - 'product' (default) -> ProductEnrichmentReview  (original 3,420-line component)
 * - 'service'           -> ServiceEnrichmentReview  (service enrichment review)
 * - 'mixed'             -> Service on top, product below
 */
export default function EnrichmentReview() {
  const offeringType = useOfferingType();

  switch (offeringType) {
    case 'service':
      return <ServiceEnrichmentReview />;
    case 'mixed':
      return (
        <div className="space-y-8">
          <div>
            <h2 className="text-lg font-semibold mb-4">Services</h2>
            <ServiceEnrichmentReview />
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4">Products</h2>
            <ProductEnrichmentReview />
          </div>
        </div>
      );
    case 'product':
    default:
      return <ProductEnrichmentReview />;
  }
}
